export default "__VITE_ASSET__DJ$PSVfC__"